// One vocabulary for the auto-match controls that appear on the banking hub,
// the reconcile workbench, and the account detail workbench. Each surface owns
// its own confirm/run flow; these constants keep the labels and explanations
// from drifting apart.
export const AUTO_MATCH_LABEL = "Auto-match";
export const AUTO_MATCH_RUNNING_LABEL = "Matching…";
/** Tested auto-match cut-off. Deliberately not user configurable: the
 * matcher's precision is validated at this score, and a per-user slider
 * silently changes which ledger entries get recorded. */
export const AUTO_MATCH_CONFIDENCE_THRESHOLD = 80;
export const AUTO_MATCH_TITLE =
  `Match imported lines whose best suggestion scores at or above the tested ${AUTO_MATCH_CONFIDENCE_THRESHOLD}% threshold`;
export const APPLY_RULES_LABEL = "Apply rules";
export const APPLY_RULES_RUNNING_LABEL = "Applying…";
export const APPLY_RULES_TITLE =
  "Apply your saved matching rules to this account's imported lines";
